<template>
  <div class="home">
    <div style="top:10px;position:absolute;left:10px;">
      <el-button type="primary" @click="back" plain>后退</el-button>
    </div>
    <div class="content">
      <el-row :gutter="12">
        <el-col :span="24" v-for="(item, i) in productList" :key="i">
          <el-button size="medium" @click="typeClick(item)">{{ item.title }}</el-button>
        </el-col>
        <el-col :span="24" v-if="productList.length < 1">
          <el-button size="medium">未添加OEE产线</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import router from "../../../../router";
export default {
  name: "home",
  data() {
    return {
      msg: "home",
      first: null,
      version: "1.0",
      dialogFormVisible: false,
      pageSize: 40,
      too: 10,
      listData: [],
      ruleForm: {
        pageSize: 40,
        too: 10
      },
      productList:[]
    };
  },
  mounted() {
    // 初始化
    this.loadProductLine();
  },
  methods: {
    typeClick(data) {
      this.$router.push({
        path: "/oee/weektracking_kpi",
        query: {
          key: data.uuid
        }
      });
    },
    back() {
      router.back();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadOeeProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }

  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/weektracking/category/category.vue